import { useApproveTimesheet } from "../../Hooks/Features/Timesheet/useApproveTimesheet";
import DatePicker from "react-multi-date-picker";
import { SkeletonDataTable } from "../Loader/Loader";
import { Dialog } from "primereact/dialog";
import { AgGridReact } from "@ag-grid-community/react";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ApproveTimesheet = (props) => {

    const { columnDefs, rowData, setRowData, getApproveTimesheet, loader, gridRef, handleRejectPopup, reject, setReject, selectStatus, filterValues, setFilterValues,
    } = useApproveTimesheet(props);

    const hasCheckedRows = rowData.filter((e) => e.is_checked === true).length > 0;

    return (
        <div className="mt-1">
            <div className="d-flex justify-content-between gap-2">
                <div className="d-flex align-items-center gap-3 w75">
                    <div className="w20">
                        <DatePicker
                            value={filterValues?.date}
                            onChange={(e) => setFilterValues((prev) => ({ ...prev, date: e, isChange: true }))}
                            range
                            rangeHover
                            placeholder="Select Dates"
                            style={{ width: "100%" }}
                            containerStyle={{ width: "100%" }}
                            inputClass="w-100 input-dd"
                            onClose={() => {
                                if (filterValues?.isChange) {
                                    getApproveTimesheet();
                                    setFilterValues((prev) => ({ ...prev, isChange: false }));
                                }
                            }}
                        />
                    </div>
                    <div className="w20">
                        <CommonFilterDropdown
                            fields={[{ key: "users", label: "Users", col: 12 }]}
                            filterValues={filterValues}
                            setFilterValues={setFilterValues}
                        />
                    </div>
                    <div className="w40">
                        <div className="d-flex align-items-center gap-2">
                            <div>
                                <input
                                    type="radio"
                                    id="send_for_approval"
                                    name="status"
                                    value="send_for_approval"
                                    checked={filterValues?.status === "send_for_approval"}
                                    onChange={() => setFilterValues((prev) => ({ ...prev, status: "send_for_approval", apiCall: true }))}
                                />
                                <label htmlFor="send_for_approval" className="ms-1">Send for Approval</label>
                            </div>
                            <div>
                                <input
                                    type="radio"
                                    id="approved"
                                    name="status"
                                    value="approved"
                                    checked={filterValues?.status === "approved"}
                                    onChange={() => setFilterValues((prev) => ({ ...prev, status: "approved", apiCall: true }))}
                                />
                                <label htmlFor="approved" className="ms-1">Approved</label>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side: Action Buttons */}
                <div className="d-flex justify-content-end gap-2 w30">
                    {selectStatus !== "approved" && (
                        loader?.loaderButtonAll ? (
                            <button className="sk-btn-confirm-primary-base sk-btn-confirm-success w40">
                                <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button>
                        ) : (
                            hasCheckedRows && filterValues?.status !== "approved" && (
                                <button className="sk-btn sk-btn-primary bg-black text-white w40" onClick={() => handleRejectPopup("checkbox", false)}>
                                    <FontAwesomeIcon icon="fa-solid fa-check" style={{ marginRight: '6px' }} /> Approve
                                </button>
                            )
                        )
                    )}

                    {hasCheckedRows && (
                        <button className="sk-btn-confirm-primary-base sk-btn-confirm-delete" onClick={() => handleRejectPopup("checkbox", true, false)}>
                            <FontAwesomeIcon icon="fa-solid fa-ban" style={{ marginRight: '6px' }} /> Reject
                        </button>

                    )}

                    <button className="sk-btn-confirm-secondary" title="Refresh" onClick={() => getApproveTimesheet()}>
                        <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                    </button>
                </div>
            </div>

            {loader?.loader ? (
                <div className="my-3 w100">
                    <SkeletonDataTable numSkeletons={10} />
                </div>
            ) : (
                <div className="ag-theme-alpine mt-1" style={{ height: "45vh" }}>
                    <AgGridReact ref={gridRef} columnDefs={columnDefs} rowData={rowData} />
                </div>
            )}

            <Dialog
                visible={reject?.visible}
                onHide={() => { setReject((prev) => ({ ...prev, visible: false })); setRowData([...rowData]); }}
                draggable={false}
                className="modal-xsmall"
                header="Reject remark"
            >
                <div>
                    <div className="text-danger">You are rejecting the selected logs. Please write the reason for it.</div>
                    <textarea
                        placeholder="Reason"
                        className="w100 mt-2 form-control"
                        rows={2}
                        style={{ resize: "none" }}
                        onChange={(e) => setReject((prev) => ({ ...prev, remark: e?.target?.value }))}
                        value={reject?.remark}
                    />
                    <div className="mt-3 d-flex gap-2 justify-content-end">
                        <button className="sk-btn-confirm-secondary" onClick={() => { setReject((prev) => ({ ...prev, visible: false })); setRowData([...rowData]); }}>
                            <FontAwesomeIcon icon="fa-solid fa-xmark" style={{ marginRight: '6px' }} /> Cancel
                        </button>
                        {loader?.loaderButton ? (
                            <button className="sk-btn-confirm-primary-base sk-btn-confirm-info w20" disabled>
                                <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button>
                        ) : (
                            <button className="sk-btn-confirm-primary-base sk-btn-confirm-info w20" onClick={() => handleRejectPopup("", true, true)}>
                                <FontAwesomeIcon icon="fa-solid fa-check" style={{ marginRight: '6px' }} /> Submit
                            </button>
                        )}
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default ApproveTimesheet;